import { useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { getQuery, setQuery } from '@i18n-ecom/lib/dist/commonjs/url';
import { ROLE_KEY, RoleType, RoleTypeMap, RoleTypeString } from '@/constants';
import { useUserModel } from '@/models';

export interface UseCollapsePanelOptions {
  onChange?: (type: RoleType) => void;
}

export const useCollapsePanel = ({ onChange }: UseCollapsePanelOptions) => {
  const history = useHistory();
  const { roleType } = useUserModel(({ roleType }) => [roleType]);
  const activeRole = useMemo(() => {
    return RoleTypeMap[
      getQuery(history.location.search, ROLE_KEY)?.toString() ||
        roleType ||
        RoleType.Seller
    ];
  }, [history.location.search]);
  const handleChange = (type: RoleType) => {
    onChange?.(type);
    history.push({
      search: setQuery(history.location.search, ROLE_KEY, RoleTypeString[type]),
      hash: history.location.hash,
    });
  };

  useEffect(() => {
    handleChange(activeRole);
  }, []);

  return {
    activeRole,
    handleChange,
  };
};
